import { useAbility } from '@shared-ui/components'
import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import type { Action, Subject } from './types'

interface ProtectedRouteProps {
    action: Action
    subject: Subject
    children: ReactNode
    redirectTo?: string
}

export const ProtectedRoute = ({
    action,
    subject,
    children,
    redirectTo = '/korisnicki-profil',
}: ProtectedRouteProps) => {
    const { ability } = useAbility()

    if (!ability.can(action, subject)) {
        return <Navigate to={redirectTo} replace />
    }

    return <>{children}</>
}
